import type { AppListenerApi } from "@src/store/rootState";
import { actions } from "@src/store/slices/experienceBuilder/common/actions";
import { selectElements } from "@src/store/slices/experienceBuilder/common/thunks/selectElements";
import { startInsertion } from "@src/store/slices/experienceBuilder/component/thunks/startInsertion";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { MessageProxy } from "@intelligems/ig-embedded-preview/MessageProxy";
import { getEmbeddedState } from "@src/store/slices/experienceBuilder/common/selectors/getEmbeddedState";
import { getEmbeddedMode } from "@src/store/slices/experienceBuilder/common/selectors/getEmbeddedMode";
import { getHighlights } from "@src/store/slices/experienceBuilder/common/selectors/getHighlights";

const { setEmbeddedNodes, setShopifyContext, setShopifyAnalyticsContext } =
  experienceBuilderSlice.actions;

export const registerMessageProxyHandlers = (
  { dispatch, getState }: AppListenerApi,
  messageProxy: MessageProxy
) => {
  messageProxy.on("ig-pageLoad", () => {
    const state = getState();
    messageProxy.send("ig-init", {
      previewState: getEmbeddedState(state),
      mode: getEmbeddedMode(state),
      highlights: getHighlights(state),
      config: { insertEnabled: false },
    });
  });
  // Preview-state-processed ack: the plugin processed a preview-state update
  // without a reload. Bridged to redux so continuation settles can `take` it
  // (see `applyAndSettle`).
  messageProxy.on("ig-setPreviewStateProcessed", () => {
    dispatch(actions.previewStateProcessed());
  });
  messageProxy.on("ig-select", (nodes) => {
    void dispatch(selectElements(nodes));
  });
  messageProxy.on("ig-insert", (context) => {
    void dispatch(startInsertion(context));
  });
  messageProxy.on("ig-embeddedNodes", (nodes) => {
    dispatch(setEmbeddedNodes(nodes));
  });
  messageProxy.on("ig:shopify", (context) => {
    dispatch(setShopifyContext(context));
  });
  messageProxy.on("ig:shopify-analytics", (context) => {
    dispatch(setShopifyAnalyticsContext(context));
  });
};
